__webpack_require__.p = "/ui-use-cdk/account-setup/";